export var omitUndefined=function(input){var obj={};for(var key in input){var val=input[key];val&&(obj[key]=val)}return obj};